module.exports = __webpack_public_path__ + "img/success.6e292585.png";